import type { HealthStatus } from '@/api/portfolio/api';

/**
 * Converts status to lowercase portfolio HealthStatus
 * Handles both capitalized ('Red', 'Yellow', 'Green') and lowercase ('red', 'yellow', 'green')
 * Portfolio uses: 'red' | 'yellow' | 'green' | 'pending'
 */
export function normalizeHealthStatus(status: string): HealthStatus {
  const normalized = status.toLowerCase();
  if (
    normalized === 'red' ||
    normalized === 'yellow' ||
    normalized === 'green' ||
    normalized === 'pending'
  ) {
    return normalized as HealthStatus;
  }
  // Default to pending if status doesn't match
  return 'pending';
}
